import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedInitData} from "../server/data/MonkeysGoldParsedInitData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {MonkeysGoldParsedGameData} from "../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldSoundConfig} from "../MonkeysGoldSoundConfig";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {TimelineLite} from "gsap";
import {MonkeysGoldGameModuleConfig} from "../MonkeysGoldGameModuleConfig";

/**
 * Created by Jerker Nord on 2020-08-10.
 */

export class MonkeysGoldSoundController {

    private _mode:string;
    private _nextMode:string;
    private _symbolHighlightPlayed:boolean;
    private _reelsAfterCollapseUpgraded:string[][];
    private _scatterCounter:number = 0;
    private _scatterAnticipationRunning:boolean = false;

    constructor() {
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.parseFeatureGameData(event.params[0]));
        EventHandler.addEventListener(this, SpinEvent.START, () => this.onSpinStart());
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onGameReady());
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_STARTED, (event:GameEvent) => this.onReelStopSpinStarted(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.REEL_STOP_SPIN_COMPLETE, (event:GameEvent) => this.onReelStopSpinAnimationComplete(event.params[0]));
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onAllReelsSpinStopped());
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    private parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._reelsAfterCollapseUpgraded = data.reelsAfterCollapseUpgraded;
        if(this._mode == GameMode.NORMAL) {
            this._scatterCounter = 0;
            this._scatterAnticipationRunning = false;
        }
    }

    private onAllReelsSpinStopped():void {
        if(this._scatterAnticipationRunning == true) {
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION);
            if(this._nextMode == GameMode.NORMAL) {
                this._scatterAnticipationRunning = false;
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION_FAIL)});
                MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.endBottomFire();
            }
        }
    }

    public playScatterLandSound(level:number):void {
        if(this._mode == GameMode.FREESPIN || this._mode == GameMode.FREESPIN_AVALANCHE) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_1)});
            return;
        }

        if(this._scatterCounter < level) {
            this._scatterCounter = level;
            if(level == 1) {
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_1)});
            } else if(level == 2) {
                this._scatterAnticipationRunning = true;
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_2)});
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION)});
            } else {
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_3)});
            }
        }
    }

    private onGameReady():void {
        (<INolimitAudioPlayer>SlotGame.sound).playTrack({
            name : MonkeysGoldSoundConfig.instance.MONKEYS_GOLD_MAIN_GAME_AMBIANCE
        });
        this.startAllMusic();
    }

    private startAllMusic():void {
        if(this._mode == GameMode.NORMAL || this._mode == GameMode.NORMAL_AVALANCHE) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.BACKGROUND_MUSIC[0],
                volume : 1
            });
        }
    }

    private onReelStopSpinAnimationComplete(reelId:number):void {
        if(this._scatterAnticipationRunning == true && reelId == 5) {
            (<INolimitAudioPlayer>SlotGame.sound).stopTrack(MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION);
            if(this._nextMode == GameMode.NORMAL) {
                this._scatterAnticipationRunning = false;
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION_FAIL)});
                MonkeysGoldGameModuleConfig.monkeysGoldScatterLandView.endBottomFire();
            }
            //If you're still and main game but are getting more then 2 scatters
            if(this._nextMode == GameMode.NORMAL_AVALANCHE && this._scatterCounter > 2) {
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION_WIN_ENDS)});
            }
            if(this._nextMode == GameMode.FREESPIN) {
                this._scatterAnticipationRunning = false;
                (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION_WIN_ENDS)});
            }
        }
    }

    private onReelStopSpinStarted(reelId:number):void {
        if(reelId == 0 && this._scatterAnticipationRunning == true) {
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SCATTER_ANTICIPATION)});
        }

        const delayTimeline:TimelineLite = new TimelineLite({delay : 0.22});
        if(GameSetting.isFastSpin == false) {
            delayTimeline.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.REELS_DEFAULT_BOUNCE[Math.floor(Math.random() * 10)],
            }), "+=" + 0.02 * reelId);

            delayTimeline.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.REELS_DEFAULT_BOUNCE[Math.floor(Math.random() * 10)],
            }), "+=" + 0.06 * reelId);

        } else {
            delayTimeline.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.REELS_DEFAULT_BOUNCE[Math.floor(Math.random() * 10)],
            }), "+=" + 0 * reelId);

            delayTimeline.add(() => (<INolimitAudioPlayer>SlotGame.sound).playTrack({
                name : MonkeysGoldSoundConfig.instance.REELS_DEFAULT_BOUNCE[Math.floor(Math.random() * 10)],
            }), "+=" + 0.06 * reelId);
        }
    }

    private onSpinStart():void {
        this._symbolHighlightPlayed = false;
    }

    public playSymbolHighlightSound():void {
        if(this._symbolHighlightPlayed == false) {
            this._symbolHighlightPlayed = true;
            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOLS_HIGHLIGHT)});
        }
    }
}